// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".timer[data-v-09c6d042]{color:#1539ed;font-size:24px;position:absolute;right:28%;top:5%}.timer.expired[data-v-09c6d042]{color:red}.success[data-v-09c6d042]{color:#1539ed;font-size:18px;position:absolute;right:30%;top:15%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
